import axios from "axios";
import { useEffect, useState } from "react";
import { GiPaintBrush } from "react-icons/gi";
import { MdCall } from "react-icons/md";
import { RiBrushAiFill } from "react-icons/ri";

const TopInfoBar = () => {
  const [coupons, setCoupons] = useState([]);

  const fetchCoupons = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/coupons`
      );

      if (res.data) {
        setCoupons(res.data?.filter((cpn) => cpn.isActive));
      }
    } catch (error) {
      console.error("Failed to fetch coupons", error);
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  return (
    <div className="hidden md:block w-full bg-[#2B1A14] text-white text-xs px-4 sm:px-8 md:px-10 lg:px-12 mx-auto">
      <div className="mx-auto flex flex-col sm:flex-row justify-between items-center py-2 gap-2 sm:gap-0">

        {/* LEFT SCROLL (Static Message) */}
        <div className="relative w-[25%] lg:w-[30%] overflow-hidden">
          <div className="pointer-events-none absolute left-0 top-0 h-full w-8 bg-gradient-to-r from-[#2B1A14] to-transparent z-10" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-[#2B1A14] to-transparent z-10" />

          <div className="flex whitespace-nowrap animate-scroll-left items-center gap-2">
            <RiBrushAiFill className="w-4 h-4" />
            <span>Exclusively females only</span>
            <GiPaintBrush className="w-4 h-4" />

            <RiBrushAiFill className="w-4 h-4" />
            <span>Exclusively females only</span>
            <GiPaintBrush className="w-4 h-4" />
          </div>
        </div>

        {/* CENTER (CALL) */}
        <div className="flex items-center gap-4 text-[#FFFFFF] flex-wrap justify-center sm:justify-start">
          <div className="flex items-center gap-1">
            <MdCall className="w-4 h-4" />
            <a href="tel:+918338822566" className="hover:underline">
              +91-83388 22566
            </a>
          </div>
        </div>

        {/* RIGHT SCROLL (COUPONS) */}
        {coupons.length > 0 && (
          <div className="relative w-[25%] lg:w-[30%] overflow-hidden">
            <div className="pointer-events-none absolute left-0 top-0 h-full w-8 bg-gradient-to-r from-[#2B1A14] to-transparent z-10" />
            <div className="pointer-events-none absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-[#2B1A14] to-transparent z-10" />

            <div className="flex whitespace-nowrap animate-scroll-left items-center gap-4">
              {coupons.map((coupon, index) => (
                <span
                  key={coupon._id || index}
                  className="flex items-center gap-1"
                >
                  🎁{coupon.code}
                </span>
              ))}

              {coupons.map((coupon, index) => (
                <span
                  key={`dup-${coupon._id || index}`}
                  className="flex items-center gap-1"
                >
                  🎁{coupon.code}
                </span>
              ))}
            </div>
          </div>
        )}

      </div>

      {/* SCROLL ANIMATION */}
      <style>
        {`
          @keyframes scrollLeft {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          .animate-scroll-left {
            display: flex;
            width: max-content;
            animation: scrollLeft 10s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default TopInfoBar;